import { StrategyPerformance } from 'api/types/httpsTypes/marketplace-performance';
import { formatTokenAmountCompact } from 'utils/FormatNumber';
import Big from 'big.js';

interface PerformanceProp {
  data: {
    title: string;
    value: string | number;
    prefix?: string;
    suffix?: string;
    tooltip?: string;
  }[];
}

export function tradesPerformance(
  info: StrategyPerformance['mainPerformance']
): PerformanceProp['data'] {
  return [
    {
      title: 'Total Trades',
      value: formatTokenAmountCompact(info?.totalTrades || 0),
      tooltip:
        'The total number of trades executed since the start + the current open trades.',
    },
    {
      title: 'Win Trades',
      value: formatTokenAmountCompact(info?.winTrades || 0),
      tooltip: 'The total number of winning trades executed since the start.',
    },
    {
      title: 'Lose Trades',
      value: formatTokenAmountCompact(info?.loseTrades || 0),
      tooltip: 'The total number of loosing trades executed since the start.',
    },
    {
      title: 'Open Trades',
      value: formatTokenAmountCompact(info?.openTrades || 0),
      tooltip: 'The total number of current open trades.',
    },
    {
      title: 'Avg. Holding Time',
      value: Big(info?.avgHoldingTime || 0).toFixed(2),
      suffix: ' hr',
      tooltip: 'The average time trades were open since the start.',
    },
    {
      title: 'Trades per Week',
      value: formatTokenAmountCompact(info?.tradesPerWeek || 0),
      tooltip:
        'The average number of executed trades per week since the start.',
    },
    {
      title: 'Best Trade',
      value: Big(info?.bestTrade || 0)
        .mul(100)
        .toFixed(2),
      prefix: info?.bestTrade && info?.bestTrade > 0 ? '+' : undefined,
      suffix: '%',
      tooltip: 'The best trade performance since the start.',
    },
    {
      title: 'Worst Trade',
      value: Big(info?.worstTrade || 0)
        .mul(100)
        .toFixed(2),
      prefix: info?.worstTrade && info?.worstTrade > 0 ? '+' : undefined,
      suffix: '%',
      tooltip: 'The worse trade performance since the start.',
    },
    {
      title: 'Avg. Trade',
      value: Big(info?.avgTrade || 0)
        .mul(100)
        .toFixed(2),
      prefix: info?.avgTrade && info?.avgTrade > 0 ? '+' : undefined,
      suffix: '%',
      tooltip: 'The average trade performance since the start.',
    },
  ];
}

export function followersPerformance(
  info: StrategyPerformance['mainPerformance']
) {
  return [
    {
      title: 'N. of Followers',
      value: formatTokenAmountCompact(info?.numberFollowers || 0),
      tooltip: 'The total current number of followers.',
    },
    {
      title: 'AUM',
      value: formatTokenAmountCompact(info?.AUM || 0),
      suffix: ' USD',
      tooltip: 'The total current assets managed by the bot.',
    },
    {
      title: 'Cum followers PnL',
      value: formatTokenAmountCompact(info?.followersPnL || 0),
      suffix: ' USD',
      tooltip: 'The total cumulated number of followers since start.',
    },
  ];
}
